module.exports = __webpack_public_path__ + "static/media/gif-no-shadow.a1f0757a.svg";